
// @ts-ignore
import TrackeData from '@/utils/trackData';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { REMOTE_LOGIN_CONFIG } from '@/utils';
// 老版域名
const DOMAIN: string = process.env.VUE_APP_JUMPURL;

@Component
export default class ShoukeBtn extends Vue {
[x: string]: any;

  @Prop() lessonInfo!: any

  @Prop() currentClass!: any

  @Prop() userInfo: any

  @Prop() currentTime!: number

  @Prop({ default: 0 }) remoteLoginCount!: number

  private href: string = window.location.href

  // 是否签约(未签约大于3讲|| 演示账号大于5 置灰处理)
  get unSigned(): boolean|0 {
    return (!this.userInfo.signed && this.lessonInfo.lessonNum > 3)
      || (this.userInfo.example && this.lessonInfo.lessonNum > 5);
  }

  // 小班(1:小班,4:本地化双师小班,6:AI小班,15:双师短线小班,17:AI短线小班)
  get isSmallClass(): boolean {
    const smallClassType: number[] = [1, 4, 6, 15, 17];
    return smallClassType.indexOf(this.currentClass.classType) !== -1;
  }

  // 教师或者是双师主讲
  get isTeacher(): boolean {
    return this.userInfo.roles.indexOf('teacher') !== -1
      || this.userInfo.doubleTeacherStatus === 2;
  }

  // 超管、管理员
  get isManage(): boolean {
    return (
      this.userInfo.roles.indexOf('manage') !== -1
      || this.userInfo.roles.indexOf('super_manager') !== -1
    );
  }

  // 快速建班
  get createClass(): boolean {
    return this.currentClass.type === 2
          && this.currentClass.createClass
          && this.currentClass.fastCreateClass === 1;
  }

  // 视频上课条件
  // get videoTypeShow(): boolean {
  // return this.lessonInfo.videoType === 1
  //   && this.currentClass.type === 1
  //   && !this.isSmallClass
  //   && this.isTeacher;
  // }

  // 点击埋点
  private clickTrack(action: string, params: any) {
    this.$track.sendClickLog(TrackeData[action], params);
  }

  // 去上课
  private handleShouke(modelType: string) {
    const count = this.remoteLoginCount || 0;
    if (count > REMOTE_LOGIN_CONFIG.MAX_COUNT) {
      this.$toast.show({ message: REMOTE_LOGIN_CONFIG.BLOCKED_MESSAGE });
      return;
    }
    const { type, classTypeId, name } = this.currentClass;
    const { lessonName, lessonNum } = this.lessonInfo;
    // 去上课埋点
    setTimeout(() => {
      this.clickTrack('PRELESSONS_ATTENDCLASS_CLICK', {
        id: classTypeId, name, lessonName, lessonNum,
      });
    }, 200);
    //  首次点击发送弹窗时长
    if (this.currentTime) {
      const clickTime: number = Date.now();
      const durationTime: number = clickTime - this.currentTime;
      this.$utils.sendAction('index', 'index', 'id-12', {
        durationTime,
      });
      this.$emit('updateCurrentTime');
    }

    // 区分兼容课程搜索和正常点击的备课点击来源
    const param = this.$route.query.searchPage ? {
      searchPage: true,
      searchBackPath: this.$route.query.backPath,
      searchText: this.$route.query.value,
      searchTextId: this.$route.query.id,
      businessId: this.currentClass.businessId,
      lessonId: this.lessonInfo.lessonId,
    } : {};
    this.$utils.sendAction('index', 'index', 'id-2', param);
    if (type === 1) {
      /**
         * 班级
         * 1、小班
         * 2、非小班
         * */
      if (this.isSmallClass) {
        this.handleToast();
      } else {
        this.handleUnSmallClass(modelType);
      }
    } else if (type === 2) {
      /**
         * 班型
         * 1、有班级
         * 2、无班级
         * */
      const { classList } = this.lessonInfo;
      if (classList && classList.length > 0) {
        this.$toast.show('该班型已有班级，请从我的课程页进入');
        this.saveHistory();
      } else {
        this.handleEmptyOfClassType();
      }
    }
  }

  // 小班toast提示
  private handleToast() {
    // 双师小班
    const doubleTeacherSmallClass: number[] = [1, 4, 15];
    // ai小班
    const aiSmallClass: number[] = [6, 17];
    const { classType } = this.currentClass;
    if (doubleTeacherSmallClass.indexOf(classType) !== -1) {
      this.$toast.show('该班级为双师小班，助教无权限授课');
    } else if (aiSmallClass.indexOf(classType) !== -1) {
      this.$toast.show('该班级为AI小班，助教无权限授课');
    }
  }

  // 非小班
  private handleUnSmallClass(modelType: string) {
    const address: string = this.getUnSmallClass(modelType);
    if (address) {
      this.saveHistory();
      window.open(address, '_blank');
    } else {
      this.$toast.show('当前账号角色权限不支持，请联系管理员给当前账号添加教师角色');
    }
  }

  // 非小班: 教师角色、超管或管理员角色、其他角色
  private getUnSmallClass(modelType: string): string {
    let url: string = '';
    if (this.isTeacher) {
      const { lessonId, lessonNum } = this.lessonInfo;
      url = `${DOMAIN}/shouke.html#/?classId=${this.currentClass.businessId}&lessonId=${lessonId}&num=${lessonNum}&model=${modelType}&newDiyFlag=${this.currentClass.newDiyFlag}`;
    } else if (this.isManage) {
      url = 'unauthorized.html#/?shouke=true';
    }
    return url;
  }

  // 班型没有班级数
  private handleEmptyOfClassType() {
    const address: string = this.getEmptyOfClassType();
    if (address) {
      // if (this.createClass) {
      //   // 当前窗口打开创建班级页面
      //   window.location.href = address;
      // } else {
      //   this.saveHistory();
      //   // 新建窗口打开
      //   window.open(address, '_blank');
      // }
      this.saveHistory();
      const timer = setTimeout(() => {
        clearTimeout(timer);
        window.location.href = address;
      }, 200);
    } else {
      this.$toast.show('当前账号角色权限不支持，请联系管理员给当前账号添加教师角色');
    }
  }

  // 获取班型下没有班级中: 是否能创建班级、教师、管理员要跳转地址
  private getEmptyOfClassType(): string {
    let url: string = '';
    const { businessId, name, courseConfigVersion } = this.currentClass;
    if (this.createClass) {
      const { lessonId, lessonNum } = this.lessonInfo;
      this.$utils.sendAction('index', 'index', 'id-13'); // 快速建班的埋点
      url = `${DOMAIN}/createClass.html#/index?classTypeId=${businessId}&newDiyFlag=${this.currentClass.newDiyFlag}&name=${name}&courseConfigVersion=${courseConfigVersion}&lessonId=${lessonId}&num=${lessonNum}&refer=shouke&referUrl=${this.href}`;
    } else if (this.isTeacher || this.isManage) {
      this.$utils.sendAction('index', 'index', 'id-14'); // 非快速建班的埋点
      url = `${DOMAIN}/createClass.html#/index?type=shouke&classTypeId=${businessId}&newDiyFlag=${this.currentClass.newDiyFlag}`;
    }
    // url = 'unauthorized.html#/noclazz';
    // } else if (this.isManage) {
    //   url = 'unauthorized.html#/?shouke=true';
    // }
    return url;
  }

  // 保存去上课记录
  private saveHistory() {
    const data = {
      type: this.currentClass.type,
      businessId: this.currentClass.businessId,
      lessonId: this.lessonInfo.lessonId,
    };
    this.$service.bk.saveHistory(data);
  }
}
